(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("paypal", [], factory);
	else if(typeof exports === 'object')
		exports["paypal"] = factory();
	else
		root["paypal"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 